import styled from 'styled-components'
import PropTypes from 'prop-types'

import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const StyledSearchInput = styled.input`
  font-size: 14px;
  width: 168px;
  height: 24px;
  padding: 0 ${props => !props.value ? '2px' : '26px'} 0 8px;
  border: 1px solid ${colors.secondary70};
  border-radius: 3px;
  cursor: text;
  color: ${colors.secondary20};
  -webkit-appearance: none;

  &::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: ${colors.secondary70};
  }

  &:focus {
    outline-style: none;
    border-color: ${colors.primary40};
  }
`

const StyledClearButton = styled(IconLink)`
  position: absolute;
  right: 9px;
`

const TransparentGradient = styled.div`
  position: absolute;
  pointer-events: none;
  width: 40px;
  top: 1px;
  bottom: 1px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 1));
  right: 1px;
}`

const SearchInput = ({
  value, onChange, onClear, onSearch, onKeyPress, onKeyDown, placeholder,
}) => {
  return (
    <InputWrapper>
      <StyledSearchInput
        id='filter_search_id'
        type='search'
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        autoComplete='search'
        onKeyDown={onKeyDown}
      />
      <TransparentGradient value={value} />
      {!!value && <StyledClearButton iconName='icon-clear-search' onClick={onClear} />}
    </InputWrapper>
  )
}


SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
}

export default SearchInput
